import { useOutletContext } from 'react-router-dom';
import type { KnownRate } from '../../data/rates';
import type {
  BalanceRow,
  ExpenseRow,
  SettlementRow,
  TripMemberRow,
  TripRow,
} from '../../data/types';

export interface TripContextValue {
  trip: TripRow;
  members: TripMemberRow[];
  expenses: ExpenseRow[];
  balances: BalanceRow[];
  settlements: SettlementRow[];
  rates: Map<string, KnownRate>;

  /** The signed-in user's seat on this trip, if they have claimed one. */
  myMemberId: string | null;
  isOwner: boolean;

  /** Name for a member id, including members who have since been removed. */
  nameOf: (memberId: string) => string;
  /** Re-fetches everything. Call after any write. */
  reload: () => void;
  /** Opens the add/edit sheet. Pass an expense to edit it. */
  openExpenseSheet: (expense?: ExpenseRow) => void;
}

/** Typed access to what TripPage passes down through <Outlet />. */
export function useTrip(): TripContextValue {
  return useOutletContext<TripContextValue>();
}
